import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { theme, transientOptions } from "shared/lib/styles";

import { AuthorAvatar } from "scmp-app/components/author/author-avatar";
import { StyledImage as AuthorAvatarImage } from "scmp-app/components/author/author-avatar/styles";
import { EntityLink } from "scmp-app/components/entity-link";

type AuthorAvatarProps = {
  $variant?: "opinion";
};

export const StyledAuthorAvatar = styled(AuthorAvatar, { ...transientOptions })<AuthorAvatarProps>`
  position: relative;

  display: inline-block;

  inline-size: 60px;
  block-size: 60px;
  box-sizing: content-box;

  ${AuthorAvatarImage} {
    padding: 1px;
  }

  ${theme.breakpoints.up("tablet")} {
    ${props =>
      props.$variant === "opinion" &&
      css`
        inline-size: 80px;
        block-size: 80px;
      `}
  }
`;

type StyledEntityLinkProps = {
  $zIndex: number;
};
export const StyledEntityLink = styled(EntityLink, { ...transientOptions })<StyledEntityLinkProps>`
  z-index: ${props => props.$zIndex};

  line-height: 0;
`;

type ContainerProps = {
  $overlap?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  column-gap: 4px;

  ${StyledEntityLink}:not(:first-of-type) {
    margin-inline-start: ${props => (props.$overlap ? "-16px" : "2px")};
  }
`;
